import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const RouterReview = new StatusEnumItem({
  id: '8FC9E2CF-6F2F-461D-A997-B703FC041488',
  name: 'Router Review',
  description:
    'A Router chooses which disciplines the Submittal needs to be sent to',
  priority: 0,
})

const DisciplineAction = new StatusEnumItem({
  id: '9C11DC5C-E551-4786-A993-E192A437FF3B',
  name: 'Discipline Action',
  description: 'Each Discipline reviews and approves the Submittal',
  priority: 1,
})

const ReturnedToDesignBuilder = new StatusEnumItem({
  id: 'BA40EB3E-505A-4CFA-974E-3C2889AAFC02',
  name: 'Returned to Design Builder',
  description: 'The Submittal has been returned to the Design Builder',
  priority: 2,
})

const Unlocked = new StatusEnumItem({
  id: '4F20736C-385C-4B7A-90F9-E78D136E3B14',
  name: 'Unlocked',
  description:
    'The Submittal has been unlocked in CIMS and SharePoint for editing',
  priority: 3,
})

export type DSStatusItem =
  | typeof RouterReview
  | typeof DisciplineAction
  | typeof ReturnedToDesignBuilder
  | typeof Unlocked

class DSStatusEnum extends StatusEnum<
  'DSStatus',
  DSStatusItem,
  DSStatusItem['name'],
  DSStatusItem['id'],
  DSStatusItem['priority']
> {
  readonly typename = 'DSStatus'
  readonly RouterReview = RouterReview
  readonly DisciplineAction = DisciplineAction
  readonly ReturnedToDesignBuilder = ReturnedToDesignBuilder
  readonly Unlocked = Unlocked

  get values() {
    return [
      this.RouterReview,
      this.DisciplineAction,
      this.ReturnedToDesignBuilder,
      this.Unlocked,
    ]
  }
}

export const DSStatus = new DSStatusEnum()
